<template>
  <el-container class="con">
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.userType === 1">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" v-if="currentUser.userType === 2">亲爱的：{{currentUser.customer.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{companyOrgs[this.index].name}}</span>
      <el-button class="but5" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but5" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main>
      <span class="text"><img class="icon_pay" src="@/assets/images/icon_pay.png" alt=""/>账簿余额查询</span>
      <div class="main">
        <img class="img" src="@/assets/images/successOrder.png" alt=""/>
        <p class="p1">当前公司为 <span style="color: rgb(239, 51, 69);">{{companyOrgs[this.index].name}}</span>，二级商户账簿余额为 <span style="color: rgb(239, 51, 69);">{{balance}}</span> 元！</p>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import {mapGetters} from "vuex";
import {querySubMerAcct, signQuery} from "../../../api/system/bank_abc";

export default {
  name: "index",
  data(){
    return{
      currentUser:'',
      saleOrgName:'',
      balance: '0.00'
    }
  },
  computed: {
    ...mapGetters(["companyOrgs"]),
    ...mapGetters(["index"])
  },
  mounted() {
    //获取当前用户
    this.currentUser = this.$store.getters.currentUser
    this.signQuery()
  },
  methods:{
    changeCompany() {
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/company/finance'})
      }).catch(() => {

      });
    },
    signQuery() {
      let param = {}
      param.companyId = this.companyOrgs[this.index].id
      param.isDeleted = 0
      // console.log(param)
      signQuery(param).then(res => {
        // console.log(res)
        if (res.data != null) {
          querySubMerAcct({
            subMerId: res.data[0].SubMerId
          }).then(res =>{
            this.balance = res.data.Balance
          })
        } else {
          this.$modal.msgError("该公司尚未签约，请签约后再进行查询！");
        }
      });
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    }
  }
}
</script>

<style scoped>
.main{
  text-align: center;
  /*width: 99%;*/
  height: 60vh;
  border: 1px solid rgb(196, 196, 196);
  margin: 10px auto;
}
.company{
  font-size: 14px;
  color:rgb(143, 143, 143)
}
.but5{
  font-size: 14px;
  color: rgb(240, 57, 74);
  border: none;
  background: white;
  font-weight: 600;
}
.img{
  margin-top: 100px;
  width: 153px;
  height: 127px;
}
.p1{
  margin-top: 20px;
  margin-left: 10px;
  /*color: rgb(239, 51, 69);*/
  font-size: 16px;
  font-weight: 700;
  line-height: 25px;
  letter-spacing: 3px;
}
.div_top{
  margin: 12px 0;
}
.icon_pay{
  width: 22px;
  height: 22px;
  display: flex;
  margin-top: 2px;
  margin-right: 8px;
}
.text{
  display: flex;
  color: rgb(239, 51, 69);
  font-size: 20px;
  font-weight: 700;
  line-height: 25px;
  letter-spacing: 1px;
  text-align: left;
  /*margin: 0 8px;*/
}
.el-step.is-simple >>> .el-step__title{
  font-size: 14px;
  max-width: 100%;
}
</style>
